// import React, { useState, useEffect, useCallback } from "react";
// import EnrollmentCard from "./enrollmentCard/EnrollmentCard";
// import EnrollmentEmployeeCard from "./enrollmentEmployeeCard/EnrollmentEmployeeCard";
// import NoEnrollmentFoundCard from "./enrollmentCard/noEnrollmentFoundCard/NoEnrollmentFoundCard";
// import useRouteParam from "../../../../../../hooks/useRouteParam";
// import { api } from "../../../../../../utils/api";
// import { getActivePlans, getActiveVEBPlans } from "../../../../../../utils/api/plan/plan";
// import {
// 	BBI_CORE_ENROLLMENT_SHORT_NAMES,
// 	BBI_VEB_ENROLLMENT_SHORT_NAMES
// } from "../../../../../../constants/BBIEnrollmentPlansShortName";
// import {
// 	ActiveEmployeeCount,
// 	SpecificEnrollmentCardGridProps
// } from "../../../../../../@types/components/enrollmentCardGrid.types";
// import { LegendIndicator } from "../../../../../../@types/charts/barCharts.types";

// import "./enrollmentCardGrid.css";

// const EnrollmentCardGrid: React.FC<SpecificEnrollmentCardGridProps> = ({ refresh, setRefresh }) => {
// 	const [highlightsTotalCount, setHighlightsTotalCount] = useState<{
// 		totalCoreEnrollments: number | null;
// 		totalEmployeeCount: number;
// 		totalVebEnrollments: number | null;
// 	}>({
// 		totalCoreEnrollments: 0,
// 		totalEmployeeCount: 0,
// 		totalVebEnrollments: 0
// 	});
// 	const [hasVEBPlans, setHasVEBPlans] = useState<boolean | null>(null);
// 	const [hasCorePlans, setHasCorePlans] = useState<boolean | null>(null);
// 	const [activeEmployeeCount, setActiveEmployeeCount] = useState<ActiveEmployeeCount>({
// 		male: 0,
// 		female: 0
// 	});
// 	const [coreEnrollmentsGraphData, setCoreEnrollmentsGraphData] = useState({
// 		labels: ["HP", "CC", "GSTD", "GLTD 1", "GLTD 2", "HOO", "KSOP", "GLI", "CCE"],
// 		datasets: [
// 			{
// 				// Zero until the real fetch resolves — never a plausible-looking placeholder number.
// 				data: [0, 0, 0, 0, 0, 0, 0, 0, 0],
// 				backgroundColor: [
// 					"#F08080",
// 					"#F28C87",
// 					"#F59D92",
// 					"#F6A296",
// 					"#F8AD9D",
// 					"#FAB9A4",
// 					"#FBC4AB",
// 					"#FDCFB2",
// 					"#FFDAB9"
// 				],
// 				borderColor: [
// 					"#F08080",
// 					"#F28C87",
// 					"#F59D92",
// 					"#F6A296",
// 					"#F8AD9D",
// 					"#FAB9A4",
// 					"#FBC4AB",
// 					"#FDCFB2",
// 					"#FFDAB9"
// 				],
// 				borderWidth: 1
// 			}
// 		]
// 	});
// 	const [VEBEnrollmentsGraphData, setVEBEnrollmentsGraphData] = useState({
// 		labels: [
// 			"Cancer",
// 			"Whole Life",
// 			"STD",
// 			"Critical Illness",
// 			"HI",
// 			"Accident",
// 			"LII",
// 			"TLA",
// 			"Doc & Rx",
// 			"Vision",
// 			"Dental"
// 		],
// 		datasets: [
// 			{
// 				// Zero until the real fetch resolves — never a plausible-looking placeholder number.
// 				data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
// 				backgroundColor: [
// 					"#615ae7",
// 					"#716be1",
// 					"#7772df",
// 					"#8681df",
// 					"#9490e0",
// 					"#9995df",
// 					"#a39fdf",
// 					"#b0ade1",
// 					"#bebce1", //
// 					"#cccbe7 ",
// 					"#d8d7ea"
// 				],
// 				borderColor: [
// 					"#615ae7",
// 					"#716be1",
// 					"#7772df",
// 					"#8681df",
// 					"#9490e0",
// 					"#9995df",
// 					"#a39fdf",
// 					"#b0ade1",
// 					"#bebce1",
// 					"#cccbe7 ",
// 					"#d8d7ea"
// 				],
// 				borderWidth: 1
// 			}
// 		]
// 	});
// 	const [totalEmployeeGraphData, setTotalEmployeeGraphData] = useState({
// 		labels: ["Female", "Male"],
// 		datasets: [
// 			{
// 				// Zero until the real fetch resolves — never a plausible-looking placeholder number.
// 				data: [0, 0],
// 				backgroundColor: ["#4059ad", "#6b9ac4"],
// 				hoverBackgroundColor: ["#617acc", "#81b3df"]
// 			}
// 		]
// 	});
// 	const [coreEnrollmentsLegendData, setCoreEnrollmentsLegendData] = useState<LegendIndicator[]>([
// 		{ labelName: "HP", colorIndicator: "#F08080" },
// 		{ labelName: "CC", colorIndicator: "#F28C87" },
// 		{ labelName: "GSTD", colorIndicator: "#F59D92" },
// 		{ labelName: "GLTD 1", colorIndicator: "#F6A296" },
// 		{ labelName: "GLTD 2", colorIndicator: "#F8AD9D" },
// 		{ labelName: "HOO", colorIndicator: "#FAB9A4" },
// 		{ labelName: "KSOP", colorIndicator: "#FBC4AB" },
// 		{ labelName: "GLI", colorIndicator: "#FDCFB2" },
// 		{ labelName: "CCE", colorIndicator: "#FFDAB9" }
// 	]);
// 	const [VEBEnrollmentsLegendData, setVEBEnrollmentsLegendData] = useState<LegendIndicator[]>([
// 		{ labelName: "Cancer", colorIndicator: "#615ae7" },
// 		{ labelName: "Whole Life", colorIndicator: "#716be1" },
// 		{ labelName: "STD", colorIndicator: "#7772df" },
// 		{ labelName: "Critical Illness", colorIndicator: "#8681df" },
// 		{ labelName: "HI", colorIndicator: "#9490e0" },
// 		{ labelName: "Accident", colorIndicator: "#9995df" },
// 		{ labelName: "GLI", colorIndicator: "#a39fdf" },
// 		{ labelName: "FPP", colorIndicator: "#b0ade1" },
// 		{ labelName: "Doc & Rx", colorIndicator: "#bebce1" },
// 		{ labelName: "Vision", colorIndicator: "#cccbe7" },
// 		{ labelName: "Dental", colorIndicator: "#d8d7ea" }
// 	]);

// 	const queryGroupNumber = useRouteParam("gn");

// 	const coreEnrollmentOptions = {
// 		scales: {
// 			x: {
// 				type: "category",
// 				labels: ["HP", "CC", "GSTD", "GLTD 1", "GLTD 2", "HOO", "KSOP", "GLI", "CCE"]
// 			},
// 			y: {
// 				beginAtZero: true
// 			}
// 		},
// 		plugins: {
// 			legend: {
// 				display: false,
// 				position: "bottom",
// 				labels: {
// 					color: "#000" // Set the color you want for the legend labels
// 				},
// 				generateLabels: (datasets: any) =>
// 					datasets.map((dataset: any) => ({
// 						text: dataset.label,
// 						fillStyle: dataset.backgroundColor,
// 						hidden: dataset.hidden,
// 						lineCap: "round",
// 						lineDash: [],
// 						lineDashOffset: 0,
// 						lineJoin: "round",
// 						lineWidth: 1,
// 						strokeStyle: dataset.borderColor,
// 						pointStyle: "circle",
// 						datasetIndex: dataset.index
// 					}))
// 			}
// 		}
// 	};

// 	const vebEnrollmentOptions = {
// 		scales: {
// 			x: {
// 				type: "category",
// 				labels: [
// 					"Cancer",
// 					"Whole Life",
// 					"STD",
// 					"Critical Illness",
// 					"HI",
// 					"Accident",
// 					"GLI",
// 					"FPP",
// 					"Doc & Rx",
// 					"Vision",
// 					"Dental"
// 				],
// 				ticks: {
// 					font: {
// 						size: 12 // Adjust the font size for x-axis labels
// 					}
// 				}
// 			},
// 			y: {
// 				beginAtZero: true,
// 				ticks: {
// 					font: {
// 						size: 12 // Adjust the font size for x-axis labels
// 					}
// 				}
// 			}
// 		},
// 		plugins: {
// 			legend: {
// 				display: false,
// 				position: "bottom",
// 				labels: {
// 					color: "#000" // Set the color you want for the legend labels
// 				},
// 				generateLabels: (datasets: any) =>
// 					datasets.map((dataset: any) => ({
// 						text: dataset.label,
// 						fillStyle: dataset.backgroundColor,
// 						hidden: dataset.hidden,
// 						lineCap: "round",
// 						lineDash: [],
// 						lineDashOffset: 0,
// 						lineJoin: "round",
// 						lineWidth: 1,
// 						strokeStyle: dataset.borderColor,
// 						pointStyle: "circle",
// 						datasetIndex: dataset.index
// 					}))
// 			}
// 		}
// 	};

// 	const totalEmployeeoptions = {
// 		plugins: {
// 			legend: {
// 				display: true,
// 				position: "bottom"
// 			}
// 		}
// 	};
// 	const getInitBenefitSummaryHighlightDetails = useCallback(async (queryGroupNumber: number) => {
// 		// The enrollment-highlights totals can't tell "no plans configured" apart from "plans exist but
// 		// nobody's enrolled" — both come back as a count of 0. Ask the plan collection directly.
// 		const [planHighlightDetails, corePlansResponse, vebPlansResponse] = await Promise.all([
// 			api.benefitSummary.getBenefitSummaryPlanHighlights(queryGroupNumber),
// 			getActivePlans(queryGroupNumber).catch(() => null),
// 			getActiveVEBPlans(queryGroupNumber).catch(() => null)
// 		]);
// 		const _hasCorePlans = (corePlansResponse?.length ?? 0) > 0;
// 		const _hasVEBPlans = (vebPlansResponse?.currentPlans?.length ?? 0) > 0;
// 		setHasCorePlans(_hasCorePlans);
// 		setHasVEBPlans(_hasVEBPlans);
// 		// console.log("ApiCheckforbbidashbarod----->>>>>", planHighlightDetails);
// 		if (planHighlightDetails) {
// 			const {
// 				activeCoreEnrollmentCountsWithIndividualPlan,
// 				activeEmployeeCountWithGender,
// 				activeVEBEnrollmentCountsWithIndividualPlan
// 			} = planHighlightDetails;
// 			// console.log("ResponseResponse", planHighlightDetails);

// 			// total number of count for the plan-highlight
// 			const _totalActiveCoreEnrollmentCount = _hasCorePlans
// 				? activeCoreEnrollmentCountsWithIndividualPlan.totalActiveCoreEnrollmentCount
// 				: null;
// 			const _totalActiveEmployeeCount = activeEmployeeCountWithGender.totalActiveEmployeeCount;
// 			const _totalActiveVEBEnrollmentCount = _hasVEBPlans
// 				? activeVEBEnrollmentCountsWithIndividualPlan.totalActiveVEBEnrollmentCount
// 				: null;

// 			// male and female count
// 			let _totalmaleEmployeeCount = 0,
// 				_totalfemaleEmployeeCount = 0;
// 			activeEmployeeCountWithGender.genders.forEach((elm: any) => {
// 				if (elm.gender === "MALE") _totalmaleEmployeeCount += elm.count;
// 				else if (elm.gender === "FEMALE") _totalfemaleEmployeeCount += elm.count;
// 			});

// 			// total core enrollment
// 			const _coreEnrollmentBarChartData: any[] = activeCoreEnrollmentCountsWithIndividualPlan.plans;

// 			const _storedCoreEnrollmentArrayData: number[] = [];
// 			Object.values(BBI_CORE_ENROLLMENT_SHORT_NAMES).forEach((renderedPlan, index) => {
// 				_coreEnrollmentBarChartData.forEach((responsePlan, index) => {
// 					const { plan, count } = responsePlan;
// 					if (renderedPlan === plan) _storedCoreEnrollmentArrayData.push(count);
// 				});
// 			});

// 			// total veb enrollment
// 			const _VEBEnrollmentBarChartData: any[] = activeVEBEnrollmentCountsWithIndividualPlan.plans;

// 			const _storedVEBEnrollmentArrayData: number[] = [];
// 			Object.values(BBI_VEB_ENROLLMENT_SHORT_NAMES).forEach((renderedPlan, index) => {
// 				_VEBEnrollmentBarChartData.forEach((responsePlan, index) => {
// 					const { plan, count } = responsePlan;
// 					if (renderedPlan === plan) _storedVEBEnrollmentArrayData.push(count);
// 				});
// 			});

// 			//total employee count
// 			const _totalEmployeePieChartData: any[] = activeEmployeeCountWithGender.genders;
// 			const _storedTotalEmployeeArrayData: number[] = [];

// 			// console.log("RESPONSE_FROM_DATA", _totalEmployeePieChartData);

// 			const sortedGenderData = _totalEmployeePieChartData.sort((a, b) => {
// 				if (a.gender === "FEMALE" && b.gender === "MALE") {
// 					return -1;
// 				} else if (a.gender === "MALE" && b.gender === "FEMALE") {
// 					return 1;
// 				} else {
// 					return 0;
// 				}
// 			});

// 			sortedGenderData.forEach((responsePlan, index) => {
// 				const { gender, count } = responsePlan;

// 				if (gender === "FEMALE") {
// 					_storedTotalEmployeeArrayData.unshift(count);
// 				} else if (gender === "MALE") {
// 					_storedTotalEmployeeArrayData.push(count);
// 				}
// 			});

// 			setHighlightsTotalCount({
// 				totalCoreEnrollments: _totalActiveCoreEnrollmentCount,
// 				totalEmployeeCount: _totalActiveEmployeeCount,
// 				totalVebEnrollments: _totalActiveVEBEnrollmentCount
// 			});

// 			setActiveEmployeeCount({
// 				male: _totalmaleEmployeeCount as unknown as number,
// 				female: _totalfemaleEmployeeCount as unknown as number
// 			});

// 			setCoreEnrollmentsGraphData({
// 				labels: ["HP", "CC", "GSTD", "GLTD 1", "GLTD 2", "HOO", "KSOP", "GLI", "CCE"],
// 				datasets: [
// 					{
// 						data: _storedCoreEnrollmentArrayData, // Replace these values with your actual data
// 						backgroundColor: [
// 							"#F08080",
// 							"#F28C87",
// 							"#F59D92",
// 							"#F6A296",
// 							"#F8AD9D",
// 							"#FAB9A4",
// 							"#FBC4AB",
// 							"#FDCFB2",
// 							"#FFDAB9"
// 						],
// 						borderColor: [
// 							"#F08080",
// 							"#F28C87",
// 							"#F59D92",
// 							"#F6A296",
// 							"#F8AD9D",
// 							"#FAB9A4",
// 							"#FBC4AB",
// 							"#FDCFB2",
// 							"#FFDAB9"
// 						],
// 						borderWidth: 1
// 					}
// 				]
// 			});

// 			setVEBEnrollmentsGraphData({
// 				labels: ["HP", "CC", "GSTD", "GLTD 1", "GLTD 2", "HOO", "KSOP", "GLI", "CCE"],
// 				datasets: [
// 					{
// 						data: _storedVEBEnrollmentArrayData,
// 						backgroundColor: [
// 							"#615ae7",
// 							"#716be1",
// 							"#7772df",
// 							"#8681df",
// 							"#9490e0",
// 							"#9995df",
// 							"#a39fdf",
// 							"#b0ade1",
// 							"#bebce1", //
// 							"#cccbe7 ",
// 							"#d8d7ea"
// 						],
// 						borderColor: [
// 							"#615ae7",
// 							"#716be1",
// 							"#7772df",
// 							"#8681df",
// 							"#9490e0",
// 							"#9995df",
// 							"#a39fdf",
// 							"#b0ade1",
// 							"#bebce1",
// 							"#cccbe7 ",
// 							"#d8d7ea"
// 						],
// 						borderWidth: 1
// 					}
// 				]
// 			});

// 			// console.log("Response I need", _storedTotalEmployeeArrayData);

// 			setTotalEmployeeGraphData({
// 				labels: ["Female", "Male"],
// 				datasets: [
// 					{
// 						data: _storedTotalEmployeeArrayData,
// 						backgroundColor: ["#4059ad", "#6b9ac4"],
// 						hoverBackgroundColor: ["#617acc", "#81b3df"]
// 					}
// 				]
// 			});
// 		}
// 	}, []);

// 	useEffect(() => {
// 		queryGroupNumber && getInitBenefitSummaryHighlightDetails(queryGroupNumber as number);

// 		if (refresh) {
// 			// console.log("Refresh + API CALL - componennt 01");
// 			queryGroupNumber && getInitBenefitSummaryHighlightDetails(queryGroupNumber as number);
// 			setRefresh(false);
// 		}
// 	}, [getInitBenefitSummaryHighlightDetails, queryGroupNumber, refresh, setRefresh]);
// 	// console.log("MAINCONSOLECHECKFORTHIS-------->>>>>>", coreEnrollmentsGraphData);
// 	return (
// 		<div className="enrollment-card-grid">
// 			<div className="enrollment-card-grid-container">
// 				<div className="enrollment-card-grid-item core-enrollments">
// 					{hasCorePlans === false ? (
// 						<NoEnrollmentFoundCard title="No Core Plans Found" />
// 					) : (
// 						<EnrollmentCard
// 							cardUIProps={{
// 								cardColor: "#E7E7E7",
// 								cardTitle: "Total Core Enrollments",
// 								overallTotal: highlightsTotalCount.totalCoreEnrollments
// 							}}
// 							chartProps={{
// 								data: coreEnrollmentsGraphData,
// 								options: coreEnrollmentOptions
// 							}}
// 							// chart={barChart}
// 							chartLegend={coreEnrollmentsLegendData}
// 						/>
// 					)}
// 				</div>
// 				<div className="enrollment-card-grid-item total-employee">
// 					<EnrollmentEmployeeCard
// 						cardUIProps={{
// 							cardColor: "#dae4fe",
// 							cardTitle: "Total Employee Count",
// 							overallTotal: highlightsTotalCount.totalEmployeeCount,
// 							maleCount: activeEmployeeCount.male,
// 							femaleCount: activeEmployeeCount.female
// 						}}
// 						chartProps={{
// 							data: totalEmployeeGraphData,
// 							options: totalEmployeeoptions
// 						}}
// 					/>
// 				</div>
// 				<div className="enrollment-card-grid-item veb-enrollments">
// 					{hasVEBPlans === false ? (
// 						<NoEnrollmentFoundCard />
// 					) : (
// 						<EnrollmentCard
// 							cardUIProps={{
// 								cardColor: "#E7E7E7",
// 								cardTitle: "Total VEB Enrollments",
// 								overallTotal: highlightsTotalCount.totalVebEnrollments,
// 								marginTopText: "0.7rem"
// 							}}
// 							chartProps={{
// 								data: VEBEnrollmentsGraphData,
// 								options: vebEnrollmentOptions
// 							}}
// 							// chart={barChart}
// 							chartLegend={VEBEnrollmentsLegendData}
// 						/>
// 					)}
// 				</div>
// 			</div>
// 		</div>
// 	);
// };

// export default EnrollmentCardGrid;
/* eslint-disable */
import React, { useState, useEffect, useCallback, useMemo } from "react";
import EnrollmentCard from "./enrollmentCard/EnrollmentCard";
import EnrollmentEmployeeCard from "./enrollmentEmployeeCard/EnrollmentEmployeeCard";
import NoEnrollmentFoundCard from "./enrollmentCard/noEnrollmentFoundCard/NoEnrollmentFoundCard";
import useRouteParam from "../../../../../../hooks/useRouteParam";
import { api } from "../../../../../../utils/api";
import { getActivePlans, getActiveVEBPlans } from "../../../../../../utils/api/plan/plan";
import {
	BBI_CORE_ENROLLMENT_SHORT_NAMES,
	BBI_VEB_ENROLLMENT_SHORT_NAMES
} from "../../../../../../constants/BBIEnrollmentPlansShortName";
import {
	ActiveEmployeeCount,
	SpecificEnrollmentCardGridProps
} from "../../../../../../@types/components/enrollmentCardGrid.types";
import { LegendIndicator } from "../../../../../../@types/charts/barCharts.types";

import "./enrollmentCardGrid.css";

/* ------------------------------------------------------------------ */
/* Helpers                                                             */
/* ------------------------------------------------------------------ */

type PlanCount = { plan: string; count: number };

type BarChartData = {
	labels: string[];
	datasets: {
		data: number[];
		backgroundColor: string[];
		borderColor: string[];
		borderWidth: number;
	}[];
};

const CORE_COLOR_RANGE: [string, string] = ["#F08080", "#FFDAB9"];
const VEB_COLOR_RANGE: [string, string] = ["#615ae7", "#d8d7ea"];

const hexToRgb = (hex: string) => {
	const h = hex.replace("#", "").trim();
	return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
};

const rgbToHex = (rgb: number[]) => "#" + rgb.map((v) => Math.round(v).toString(16).padStart(2, "0")).join("");

/** Generates `count` colors evenly interpolated between two hex colors. */
const generateColors = (count: number, [start, end]: [string, string]): string[] => {
	if (count <= 0) return [];
	if (count === 1) return [start];
	const a = hexToRgb(start);
	const b = hexToRgb(end);
	return Array.from({ length: count }, (_, i) => {
		const t = i / (count - 1);
		return rgbToHex(a.map((v, idx) => v + (b[idx] - v) * t));
	});
};

/**
 * Merges duplicate plan names, then orders them: plans listed in `knownOrder`
 * come first (in that order), any other plan the API returns is appended.
 * Nothing the API returns is dropped, and label/value always stay paired.
 */
const normalizePlans = (plans: PlanCount[] | undefined, knownOrder: string[]): PlanCount[] => {
	const totals = new Map<string, number>();
	(plans ?? []).forEach(({ plan, count }) => {
		if (!plan) return;
		totals.set(plan, (totals.get(plan) ?? 0) + (Number(count) || 0));
	});

	const ordered: PlanCount[] = [];
	knownOrder.forEach((name) => {
		if (totals.has(name)) {
			ordered.push({ plan: name, count: totals.get(name) as number });
			totals.delete(name);
		}
	});
	totals.forEach((count, plan) => ordered.push({ plan, count }));
	return ordered;
};

const buildBarChartData = (plans: PlanCount[], colorRange: [string, string]): BarChartData => {
	const colors = generateColors(plans.length, colorRange);
	return {
		labels: plans.map((p) => p.plan),
		datasets: [
			{
				data: plans.map((p) => p.count),
				backgroundColor: colors,
				borderColor: colors,
				borderWidth: 1
			}
		]
	};
};

const buildLegend = (chartData: BarChartData): LegendIndicator[] =>
	chartData.labels.map((labelName, i) => ({
		labelName,
		colorIndicator: chartData.datasets[0].backgroundColor[i]
	}));

const emptyBarChart = (): BarChartData => buildBarChartData([], CORE_COLOR_RANGE);

const buildBarOptions = (fontSize?: number) => {
	const ticks = fontSize ? { ticks: { font: { size: fontSize } } } : {};
	return {
		scales: {
			// No hardcoded `labels` — Chart.js reads them from the data.
			x: { type: "category", ...ticks },
			y: { beginAtZero: true, ...ticks }
		},
		plugins: {
			legend: {
				display: false,
				position: "bottom",
				labels: { color: "#000" }
			}
		}
	};
};

/* ------------------------------------------------------------------ */
/* Component                                                           */
/* ------------------------------------------------------------------ */

const EnrollmentCardGrid: React.FC<SpecificEnrollmentCardGridProps> = ({ refresh, setRefresh, onLoaded }) => {
	const [highlightsTotalCount, setHighlightsTotalCount] = useState<{
		totalCoreEnrollments: number | null;
		totalEmployeeCount: number;
		totalVebEnrollments: number | null;
	}>({
		totalCoreEnrollments: 0,
		totalEmployeeCount: 0,
		totalVebEnrollments: 0
	});
	const [hasVEBPlans, setHasVEBPlans] = useState<boolean | null>(null);
	const [hasCorePlans, setHasCorePlans] = useState<boolean | null>(null);
	const [activeEmployeeCount, setActiveEmployeeCount] = useState<ActiveEmployeeCount>({
		male: 0,
		female: 0
	});

	// Start empty — labels and values arrive together from the API.
	const [coreEnrollmentsGraphData, setCoreEnrollmentsGraphData] = useState<BarChartData>(emptyBarChart);
	const [VEBEnrollmentsGraphData, setVEBEnrollmentsGraphData] = useState<BarChartData>(emptyBarChart);
	const [totalEmployeeGraphData, setTotalEmployeeGraphData] = useState({
		labels: ["Female", "Male"],
		datasets: [
			{
				data: [0, 0],
				backgroundColor: ["#4059ad", "#6b9ac4"],
				hoverBackgroundColor: ["#617acc", "#81b3df"]
			}
		]
	});

	const queryGroupNumber = useRouteParam("gn");

	// Legends are derived from the chart data, so they can never drift apart.
	const coreEnrollmentsLegendData = useMemo(() => buildLegend(coreEnrollmentsGraphData), [coreEnrollmentsGraphData]);
	const VEBEnrollmentsLegendData = useMemo(() => buildLegend(VEBEnrollmentsGraphData), [VEBEnrollmentsGraphData]);

	const coreEnrollmentOptions = useMemo(() => buildBarOptions(), []);
	const vebEnrollmentOptions = useMemo(() => buildBarOptions(12), []);
	const totalEmployeeoptions = useMemo(() => ({ plugins: { legend: { display: true, position: "bottom" } } }), []);

	const getInitBenefitSummaryHighlightDetails = useCallback(
		async (groupNumber: number, isCancelled: () => boolean = () => false) => {
			// The highlights totals can't tell "no plans configured" apart from "plans exist but
			// nobody's enrolled" — both come back as 0. Ask the plan collection directly.
			const [planHighlightDetails, corePlansResponse, vebPlansResponse] = await Promise.all([
				api.benefitSummary.getBenefitSummaryPlanHighlights(groupNumber),
				getActivePlans(groupNumber).catch(() => null),
				getActiveVEBPlans(groupNumber).catch(() => null)
			]);

			if (isCancelled()) return; // a newer request has replaced this one

			const _hasCorePlans = (corePlansResponse?.length ?? 0) > 0;
			const _hasVEBPlans = (vebPlansResponse?.currentPlans?.length ?? 0) > 0;
			setHasCorePlans(_hasCorePlans);
			setHasVEBPlans(_hasVEBPlans);

			if (!planHighlightDetails) return;

			const {
				activeCoreEnrollmentCountsWithIndividualPlan,
				activeEmployeeCountWithGender,
				activeVEBEnrollmentCountsWithIndividualPlan
			} = planHighlightDetails;

			// ---- totals ----
			setHighlightsTotalCount({
				totalCoreEnrollments: _hasCorePlans
					? activeCoreEnrollmentCountsWithIndividualPlan.totalActiveCoreEnrollmentCount
					: null,
				totalEmployeeCount: activeEmployeeCountWithGender.totalActiveEmployeeCount,
				totalVebEnrollments: _hasVEBPlans
					? activeVEBEnrollmentCountsWithIndividualPlan.totalActiveVEBEnrollmentCount
					: null
			});

			// ---- gender ----
			let male = 0;
			let female = 0;
			activeEmployeeCountWithGender.genders.forEach((elm: any) => {
				if (elm.gender === "MALE") male += elm.count;
				else if (elm.gender === "FEMALE") female += elm.count;
			});
			setActiveEmployeeCount({ male, female });
			setTotalEmployeeGraphData((prev) => ({
				...prev,
				datasets: [{ ...prev.datasets[0], data: [female, male] }] // matches labels: Female, Male
			}));

			// ---- core + VEB bar charts: names AND counts straight from the API ----
			const corePlans = normalizePlans(
				activeCoreEnrollmentCountsWithIndividualPlan.plans,
				Object.values(BBI_CORE_ENROLLMENT_SHORT_NAMES) as string[]
			);
			const vebPlans = normalizePlans(
				activeVEBEnrollmentCountsWithIndividualPlan.plans,
				Object.values(BBI_VEB_ENROLLMENT_SHORT_NAMES) as string[]
			);

			setCoreEnrollmentsGraphData(buildBarChartData(corePlans, CORE_COLOR_RANGE));
			setVEBEnrollmentsGraphData(buildBarChartData(vebPlans, VEB_COLOR_RANGE));
		},
		[]
	);

	useEffect(() => {
		// useRouteParam is undefined on the first render; keep the page loader up until the group number arrives.
		if (!queryGroupNumber) return;

		let cancelled = false;
		getInitBenefitSummaryHighlightDetails(queryGroupNumber as number, () => cancelled).finally(() => {
			if (!cancelled) onLoaded?.();
		});

		if (refresh) setRefresh(false);

		return () => {
			cancelled = true;
		};
	}, [getInitBenefitSummaryHighlightDetails, queryGroupNumber, refresh, setRefresh, onLoaded]);

	return (
		<div className="enrollment-card-grid">
			<div className="enrollment-card-grid-container">
				<div className="enrollment-card-grid-item core-enrollments">
					{hasCorePlans === false ? (
						<NoEnrollmentFoundCard title="No Core Plans Found" />
					) : (
						<EnrollmentCard
							cardUIProps={{
								cardColor: "#E7E7E7",
								cardTitle: "Total Core Enrollments",
								overallTotal: highlightsTotalCount.totalCoreEnrollments
							}}
							chartProps={{
								data: coreEnrollmentsGraphData,
								options: coreEnrollmentOptions
							}}
							chartLegend={coreEnrollmentsLegendData}
						/>
					)}
				</div>
				<div className="enrollment-card-grid-item total-employee">
					<EnrollmentEmployeeCard
						cardUIProps={{
							cardColor: "#dae4fe",
							cardTitle: "Total Employee Count",
							overallTotal: highlightsTotalCount.totalEmployeeCount,
							maleCount: activeEmployeeCount.male,
							femaleCount: activeEmployeeCount.female
						}}
						chartProps={{
							data: totalEmployeeGraphData,
							options: totalEmployeeoptions
						}}
					/>
				</div>
				<div className="enrollment-card-grid-item veb-enrollments">
					{hasVEBPlans === false ? (
						<NoEnrollmentFoundCard />
					) : (
						<EnrollmentCard
							cardUIProps={{
								cardColor: "#E7E7E7",
								cardTitle: "Total VEB Enrollments",
								overallTotal: highlightsTotalCount.totalVebEnrollments,
								marginTopText: "0.7rem"
							}}
							chartProps={{
								data: VEBEnrollmentsGraphData,
								options: vebEnrollmentOptions
							}}
							chartLegend={VEBEnrollmentsLegendData}
						/>
					)}
				</div>
			</div>
		</div>
	);
};

export default EnrollmentCardGrid;
